import { createContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setToken, setUser, setAuthorities } from '../store/authSlice';
import { ApiHelper } from '../utils/apiHelper';
import qs from 'qs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Toastify CSS'i dahil edin

export const JWTContext = createContext();

const JWTProvider = ({ children }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);

    const login = async (email, password) => {
        try {
            console.log(email, password);
            const response = await ApiHelper.post('/login', qs.stringify({ email, password }));

            const { data } = response;

            if (data?.token) {
                dispatch(setToken(data.token));
                dispatch(setUser(data.user || {}));
                dispatch(setAuthorities(data.authorities || []));
                toast.success('Login successful!'); // Başarılı mesajı
                return data;
            } else {
                throw new Error('Invalid credentials');
            }
        } catch (error) {
            console.error('Login failed:', error);
            toast.error('Login failed. Please check your credentials.'); // Hata mesajı
            throw error;
        }
    };

    const register = async (email, password) => {
        try {
            console.log(email, password);
            const response = await ApiHelper.post('/register', { email, password });
            const { data } = response;

            if (data?.success) {
                toast.success('Registration successful!'); // Başarılı mesajı
            } else {
                throw new Error('Registration failed');
            }
        } catch (error) {
            console.error('Registration failed:', error);
            toast.error('Registration failed. Please try again.'); // Hata mesajı
            throw error;
        }
    };

    const logout = () => {
        dispatch(setToken(''));
        dispatch(setUser({}));
        dispatch(setAuthorities([]));
        toast.info('Başarıyla çıkış yapıldı.'); // Çıkış mesajı
    };

    return (
        <JWTContext.Provider value={{ token, login, logout, register }}>
            {children}
        </JWTContext.Provider>
    );
};

export default JWTProvider;
